module.exports = __webpack_public_path__ + "img/background-image.39925b3c.svg";